<div class="order-overview-tab">
  <div class="object-header">
    <div class="object-title">
      <gc-text [variant]="'minorHeading'">{{
        building()?.address ?? deliveryPoint()?.address
      }}</gc-text>
      @if (displayBom() && isBom()) {
        <gc-pill [color]="'caution'">{{
          'installationReportV2.orderOverviewTab.bomTag' | translate
        }}</gc-pill>
      }
      @if (deliveryPointIsDone() || buildingIsDone()) {
        <gc-pill [color]="'success'">{{
          'installationReportV2.orderOverviewTab.doneTag' | translate
        }}</gc-pill>
      }
    </div>
  </div>
  @if (!deliveryPointIsDone() && displayBom()) {
    <app-delivery-point-bom
      [overview]="overview()"
      [isBom]="isBom()"
      [isSaving]="isBomSaving()"
      (bomMarked)="bomMarked.emit($event)"
    />
  }
  <hr class="divider" />

  @if (deliveryPoint(); as deliveryPoint) {
    <gc-text [variant]="'paragraph'">{{
      'installationReportV2.orderOverviewTab.infoText' | translate
    }}</gc-text>

    <div class="order-information">
      <gc-text [variant]="'largeParagraphBold'">{{
        'installationReportV2.orderOverviewTab.subHeader' | translate
      }}</gc-text>

      <app-info-row
        [label]="'portConnectionStatus.installationDate'"
        [value]="deliveryPoint.installationDate"
        layout="inline"
      />
      <app-info-row
        [label]="'installationReportV2.preinstallationTab.macAddressInputLabel'"
        [value]="deliveryPoint.macId"
        layout="inline"
      />
      <app-info-row
        [label]="'installationReportV2.preinstallationTab.netAdmin'"
        [value]="deliveryPoint.accessId"
        layout="inline"
      />
    </div>
  }
</div>
